import { useContext, useEffect, useState } from "react";
import "../../Inventory Management System/Styles/tax.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Select from "react-select";

import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";
// import ApiConfig from "../../../api/ApiConfig";
import { getWithAuthCall, simplePostCall, simplePostCallIVT } from "../../../api/ApiServices";
import { notifyError, notifySuccess } from "../../../toaster/notify";


const Addvariant = () => {
  const {selectedStoreID,sidebar,setActiveTab,ApiConfig}=useContext(AppContext)

  const navigetion = useNavigate()
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [unitList, setUnitList] = useState([])
  const [addVariant, setAddVariant] = useState({
    name: "",
    groupname: "",
    unit_of_measurement: "",
    size: "",
    quantity: ""


  })


const [errors, setErrors] = useState({
  name: "",
  groupname: "",
  unit_of_measurement: "",
  size: "",
  quantity: "",
});

  

  console.log("addVariant>>>>", addVariant)

  const DeparmnetList = [
    { value: "Size", label: "Size" },
    { value: "Portion", label: "Portion" },
    { value: "Quantity", label: "Quantity" },
    { value: "Portion Size", label: "Portion Size" },
    { value: "Customisation", label: "Customisation" },
    { value: "Preparation", label: "Preparation" },
  ]





  const handleselectData=(select,)=>{
    console.log("unit_of_measurement>>>>",select)
    setAddVariant({
      ...addVariant,
      unit_of_measurement:select.value
    })

  }

  const handleselectDepartment=(select,)=>{
    console.log("groupname>>>>",select)
    setAddVariant({
      ...addVariant,
      groupname:select.value
    })

  }

  const validateForm = () => {
    let isValid = true;
    let validationErrors = {};
  
    // Check if the variant name is empty
    if (!addVariant.name) {
      validationErrors.name = "Variant Name is required.";
      isValid = false;
    }
  
    // Check if the group name is selected
    if (!addVariant.groupname) {
      validationErrors.groupname = "Department is required.";
      isValid = false;
    }
  
    // Check if the unit of measurement is selected
    if (!addVariant.unit_of_measurement) {
      validationErrors.unit_of_measurement = "Unit of Measure is required.";
      isValid = false;
    }
  
    // Check if the size is provided
    if (!addVariant.size) {
      validationErrors.size = "Size is required.";
      isValid = false;
    }
  
    // Check if the quantity is provided and is a number
    if (!addVariant.quantity || isNaN(addVariant.quantity)) {
      validationErrors.quantity = "Minimum Quantity is required ";
      isValid = false;
    }
  
    setErrors(validationErrors);
    return isValid;
  };

  const onSubmitAddVariationData=()=>{

    if (!validateForm()) {
      return; // Don't submit if validation fails
    }
  

    const body={
      "name": addVariant?.name,
      "groupname": addVariant?.groupname,
      "status": true,
      "shop_id": selectedStoreID,
      "minimum_quantity": addVariant?.quantity,
      "size":addVariant?.size,
      "unit_of_measurment": addVariant?.unit_of_measurement
    }


    simplePostCallIVT(ApiConfig.ADD_VARIATION,JSON.stringify(body))
    .then((res)=>{
      console.log("submit varation response>>>",res)
      if(res.success === true){
        notifySuccess(res.message)
        navigetion("/BaseMenu")
        setActiveTab("Variants")
        setAddVariant("");
        setErrors({});
      } else {
        notifyError(res.message)

      }
    })
    .catch((err)=>{
      console.log("submit varation error>>>",err)
    })


  }

  const getUnitMasurmentList = () => {
    getWithAuthCall(ApiConfig?.UNIT_MEASUREMNET)
      .then((res) => {
        console.log("getUnitMasurmentList>>>>", res.data)
        const unitresponse = res.data.map((item) => ({
          value: item.id,
          label: item.unit_of_measurement
        }))
        setUnitList(unitresponse)
      })
      .catch((err) => {
        console.log("getUnitMasurmentList>>>>", err)
      })
  }


  useEffect(() => {
    getUnitMasurmentList()
  }, [])


  return (
    <>
    <div
    className={sidebar ? "taskMain " : "cx-active taskMain"}
    id="cx-main"
  >
    <div className="role-content">
    <div className="sub-header-role ">
        <h6 className="mt-2">Menu List</h6>
      </div>
      <div className="p-2">



        <div className="">
          <div className="flex flex-column">
            {/* <form> */}
            <div className="w-full bg-white p-4  border border-gray-300">
              <div className="row g-3">
                {/* Department */}
                <div className="col-md-4" >
                  <label htmlFor="department" className="form-label tax-type-label">
                    Department<span style={{ color: "red" }}>*</span>
                  </label>

                  <div className="position-relative z-3 w-full">

                    <Select
                      options={DeparmnetList}
                      onChange={handleselectDepartment}
                      placeholder="Select Department"
                    />
                         {errors.groupname && (
              <span style={{ color: "red" }}>{errors.groupname}</span>
            )}
                  </div>



                </div>

                {/* Variant Name */}
                <div className="col-md-4">
                  <label
                    htmlFor="variantName"
                    className="form-label tax-type-label"
                  >
                    Variant Name<span style={{ color: "red" }}>*</span>
                  </label>

                  <input
                    type="text"
                    id="variantName"
                    className="form-control tax-type-label"
                    name="variantName"
                    placeholder="Variant Name"
                    onChange={(e) => setAddVariant({
                      ...addVariant,
                      name: e.target.value
                    })}
                  />
                   {errors.name && <span style={{ color: "red" }}>{errors.name}</span>}
                </div>

                {/* Unit of Measure */}
                <div className="col-md-4">
                  <label
                    htmlFor="unitOfMeasure"
                    className="form-label tax-type-label tax-type-label"
                  >
                    Unit of Measure<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    options={unitList}
                    onChange={handleselectData}
                    placeholder="Select Unit of Measure"
                  />
   {errors.unit_of_measurement && (
              <span style={{ color: "red" }}>{errors.unit_of_measurement}</span>
            )}
                </div>
              </div>
              <div className="row g-3">
                {/* Department */}
                <div className="col-md-4">
                  <label
                    htmlFor="department"
                    className="form-label tax-type-label"
                  >
                    Size<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    id="variantName"
                    className="form-control tax-type-label"
                    name="variantName"
                    placeholder="Size"
                    onChange={(e) => setAddVariant({
                      ...addVariant,
                      size: e.target.value
                    })}
                  />
                     {errors.size && <span style={{ color: "red" }}>{errors.size}</span>}
                </div>

         
                <div className="col-md-4">
                  <label
                    htmlFor="variantName"
                    className="form-label tax-type-label"
                  >
                    Minimum Quantity<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    id="variantName"
                    className="form-control tax-type-label"
                    name="variantName"
                    placeholder="Minimum Quantity"
                    onChange={(e) => setAddVariant({
                      ...addVariant,
                      quantity: e.target.value
                    })}
                  />
                       {errors.quantity && (
              <span style={{ color: "red" }}>{errors.quantity}</span>
            )}
                </div>
              </div>
            </div>                                                                                                                                                                                                                                                                                                                                                                                                 
            <div className="row">
              <div className="d-flex justify-content-end gap-3 pt-2">
                
                <button className="btn " style={{backgroundColor:"#53B7E8", color:"#fff"}} type="button"
                onClick={onSubmitAddVariationData}
                >
                  <label className="add-text">Add variantions</label>
                </button>
                <button className="btn" style={{border:"1px solid #53B7E8", color:"#53B7E8"}} type="button"
                onClick={()=>navigetion("/BaseMenu")}
                >
                  <label className=" add-"> Cancel</label>
                </button>

              </div>
            </div>
            {/* </form> */}
          </div>
        </div>
      </div>
      </div>
      </div>
    </>
  );
};

export default Addvariant;
